import api from '../../api';
import { AccountSubscriber } from '../../types';
import repository from './client-subscriber-repository';
import eventBus from '../../messaging/event-bus';
import { SubscribedToAccount, UnsubscribedFromAccount } from '../../messaging/events';

let subscribeHandler = (accountId: string, userId: string): Promise<string> => api
  .post(`accounts/${accountId}/subscribers`, { userIds: [userId] })
  .then(response => (response.data[0] as AccountSubscriber).id);

let unsubscribeHandler = (id: string): Promise<void> => api
  .delete(`account-subscribers/${id}`)
  .then();

export function setSubscribeHandler(handler: SubscribeHandler): void {
  subscribeHandler = handler;
}

export function setUnsubscribeHandler(handler: UnsubscribeHandler): void {
  unsubscribeHandler = handler;
}

export function subscribe(accountId: string, userId: string): Promise<AccountSubscriber> {
  return subscribeHandler(accountId, userId).then((accountSubscriberId: string) => repository
    .find(accountSubscriberId)
    .then((accountSubscriber: AccountSubscriber) => {
      eventBus.$emit(SubscribedToAccount.eventName, new SubscribedToAccount(accountSubscriber));
      return accountSubscriber;
    }));
}

export function unsubscribe(id: string): Promise<void> {
  return repository
    .find(id)
    .then((accountSubscriber: AccountSubscriber) => unsubscribeHandler(id)
      .then(() => {
        eventBus.$emit(
          UnsubscribedFromAccount.eventName,
          new UnsubscribedFromAccount(accountSubscriber),
        );
      }));
}

export interface SubscribeHandler {
  (accountId: string, userId: string): Promise<string>;
}

export interface UnsubscribeHandler {
  (id: string): Promise<void>;
}

export function subscribeToAccounts(userId, accountIds): Promise<AccountSubscriber[]> {
  return api
    .post(`users/${userId}/account-subscriptions`, { accountIds })
    .then((response) => {
      const accountSubscribers = response.data as AccountSubscriber[];
      accountSubscribers.forEach((accountSubscriber: AccountSubscriber) => {
        eventBus.$emit(SubscribedToAccount.eventName, new SubscribedToAccount(accountSubscriber));
      });
      return accountSubscribers;
    });
}
